import React, { Fragment, useEffect, useState } from "react";
import { Col, Form, Row, Button, Card, ProgressBar } from "react-bootstrap";
import { Link } from "react-router-dom";
import { getDateWithOffset } from "../../Shared/Utility/GetDateWithOffset";
import { AssessmentResult } from "../Models/Assessment";
import { ArticleResultList } from "../ContinuingCertification/Components/ArticleResultList";
import { configService } from "../../../Services/Config/ConfigService";

interface IProps {
    assessment: AssessmentResult;
}

export function AssessmentCard(props: IProps) {

const [detailVisible, setDetailVisible] = useState<boolean>(false);
const [articleAccessUrl, setArticleAccessUrl] = useState<string>(null);

useEffect(() => {
    const getArticleAccessUrl = async () => {
        let cfg = (await configService.getConfiguration()).ArticleAccessUrl;
        setArticleAccessUrl(cfg);
        

    }
    getArticleAccessUrl();
}, []);

const numPassed = props.assessment.ccArticleResults.filter(_ => _.isPass).length;
const numFailed = props.assessment.ccArticleResults.filter(_ => !_.isPass).length;
const totalAttempts = props.assessment.articleFailureMax + props.assessment.articleRequirement;
const percentPassed = numPassed / props.assessment.articleRequirement * 100;
const percentFailed = numFailed / props.assessment.articleFailureMax * 100;
var examDueHeader = props.assessment.isArticleBasedExam ? "Article Exams Due" : "Exam Due";
var articleStatusMessage = "";

if (props.assessment.isArticleBasedExam) {
    if (numFailed > 9){
        articleStatusMessage = "You have exceeded the number of failed article exams allowed. Unfortunately, you were unsuccessful with article exams. You will need to apply/pay for, and pass, the traditional 10-Year CC/recertification exam in order to maintain your certification.";
    }
    else if (numFailed == 9 && numPassed < props.assessment.articleRequirement) {
        articleStatusMessage = `You have passed ${numPassed} of ${props.assessment.articleRequirement} article exams needed to pass with ${totalAttempts - numFailed - numPassed} article exams remaining. If you fail one more article exam before you pass 30, no further attempts will be allowed.`
    }
    else if (numPassed < props.assessment.articleRequirement){
        articleStatusMessage = `You have passed ${numPassed} of ${props.assessment.articleRequirement} article exams needed to pass with ${totalAttempts - numFailed - numPassed} article exams remaining.`
    }
    else {
        articleStatusMessage = `Congratulations!  You have passed ${numPassed} of ${props.assessment.articleRequirement} article exams needed to pass.`
    }
}

const getFormattedDueDate = () => {
    if (isNaN(Date.parse(props.assessment.dueDate)) || props.assessment.isArticleBasedExam) return getDateWithOffset(props.assessment.dueDate).toLocaleDateString();

    return getDateWithOffset(props.assessment.dueDate).getFullYear().toString();
}

const articleResultsExist = () => {
    return props.assessment.isArticleBasedExam && 
           props.assessment.ccArticleResults.length > 0;
}

return (
        <Fragment>
            <Row className="align-items-end">
                <Col>
                    <Form.Group controlId="licenseNumber">
                        <Form.Label className="font-weight-bolder mb-1 pp-font-size-smaller"></Form.Label>
                        <Form.Text className="font-weight-bolder mb-1 pp-font-size-smaller">{props.assessment.certificationName.toUpperCase()}</Form.Text>
                    </Form.Group>
                </Col>
                <Col>
                { !props.assessment.releaseGrades && 
                    <Form.Group controlId="dueDate">
                        <Form.Label className="font-weight-bolder mb-1 pp-font-size-smaller">{examDueHeader}</Form.Label>
                        <Form.Text>{getFormattedDueDate()}</Form.Text>                    
                    </Form.Group>
                }
                </Col>
                <Col>
                { props.assessment.releaseGrades && 
                    <Form.Group controlId="link">
                        <Form.Label className="font-weight-bolder mb-1 pp-font-size-smaller">Result</Form.Label>
                        <Form.Text><Link to={`ExaminationHistory`}>Available</Link></Form.Text>                    
                    </Form.Group>
                }
                </Col>
            </Row>
            { props.assessment.isArticleBasedExam &&
            <div>
                <Row noGutters className="align-items-end">
                    <Col className="text-center col-6">
                        <Form.Label className="mb-0 font-weight-bold pp-font-size-smaller">Passed</Form.Label> 
                    </Col>
                    <Col className="text-center col-3">
                        <Form.Label className="mb-0 font-weight-bold pp-font-size-smaller">Failed</Form.Label> 
                    </Col>
                    <Col className="text-center col-2">
                        <Form.Label className="mb-0 font-weight-bold pp-font-size-smaller">Completed</Form.Label> 
                    </Col>
                </Row>
                <Row noGutters className="align-items-center mb-0">
                    <Col className="col-6 text-right" style={{height: "26px" }}>
                        <Form.Group controlId="articleProgress">
                            <div className="d-flex flex-row ">
                                <div className="w-75 mb-1 mt-1">
                                    <ProgressBar variant="pp-secondary" role="progressbar" now={percentPassed} max={100} ></ProgressBar>
                                </div>
                                <Form.Text className="ml-1">{numPassed}/{props.assessment.articleRequirement}</Form.Text>        
                            </div>                  
                        </Form.Group>
                    </Col>
                    <Col className="text-right col-3" style={{height: "26px" }}>
                        <Form.Group controlId="articleFailureProgress">
                            <div className="d-flex flex-row ">
                                <div className="w-75 mb-1 mt-1">
                                    <ProgressBar variant="pp-primary" role="progressbar" now={percentFailed} max={100} ></ProgressBar>
                                </div>
                                <Form.Text className="ml-1">{numFailed}/{props.assessment.articleFailureMax}</Form.Text>        
                            </div>                  
                        </Form.Group>
                    </Col>
                    <Col className="text-center col-2">
                        <Form.Label className="mb-0 pp-font-size-smaller">{numPassed + numFailed}/{props.assessment.articleRequirement + props.assessment.articleFailureMax}</Form.Label> 
                    </Col>
                </Row>
                <Row noGutters>
                    <Col className="text-center col-11">
                        <Form.Label className="font-weight-bolder mt-2 pp-font-size-smaller">{articleStatusMessage}</Form.Label>
                    </Col>
                </Row>
            </div>
            }
            { detailVisible &&
                <Row>
                    <ArticleResultList articleResults={props.assessment.ccArticleResults}/>
                </Row>
            }

            <Card bsPrefix="border-0 pp-align-self-end mt-2">
                { props.assessment.isArticleBasedExam && <a href={articleAccessUrl} target="_blank"><Button variant="pp-primary" className="mb-3 mr-1">Access Article Exams<i className="ml-1 las la-external-link-alt"></i></Button></a>}
                { articleResultsExist() && <Button className="mb-3" variant="outline-pp-primary" onClick={() => setDetailVisible(!detailVisible)}>{detailVisible ? "Hide" : "Show"} Detail</Button>}
            </Card>
            <div className="pp-font-size-smallest">* Clicking 'Access Article Exams' will navigate you to the article portal</div>
            <hr className="mt-0"/>
        </Fragment>
    );
}

export default AssessmentCard;